export class Product{

    private id:string;
    private name:string;
    private price:number;

    constructor(id:string, name:string){
        this.id = id;
        this.name = name;
    }

    public getId():string{
        return this.id;
    }

    public getPrice():number{
        return this.price;
    }

    public setPrice(price:number){
        this.price = price;
        // console.log(this.name, ": ", this.price)
    }

    public getName():string{
        return this.name;
    }
}